export const isSessionStorageAllowed = (): boolean => {
  let isAllowed = false;

  try {
    const storage = window.sessionStorage;
    storage.setItem('test', 'test');
    storage.removeItem('test');
    isAllowed = true;
  } catch (_exception) {
    isAllowed = false;
  }

  return isAllowed;
};

export const isLocalStorageAllowed = (): boolean => {
  let isAllowed = false;

  try {
    if (window.localStorage) return true;
  } catch (_exception) {
    isAllowed = false;
  }

  return isAllowed;
};

export const safeSessionStorage = {
  getItem: (name: string) =>
    isSessionStorageAllowed() ? sessionStorage.getItem(name) : null,
  setItem: (name: string, value: string) => {
    if (isSessionStorageAllowed()) sessionStorage.setItem(name, value);
  },
  removeItem: (name: string) => {
    if (isSessionStorageAllowed()) sessionStorage.removeItem(name);
  },
};
